import React, { PureComponent } from 'react';

import S from './style.css';
import logoImage from './postlight-labs-animation.gif';

export default class Header extends PureComponent {
  render() {
    return (
      <header className={S.banner}>
        <a
          href="https://postlight.com/labs"
          rel="noopener noreferrer"
          target="_blank"
        >
          <img alt="logo" className={`${S.logo}`} src={logoImage} />
        </a>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Header/index.jsx